<template>
	<section id="app-main-v3">
		<div class="admin-v3">
			<router-view ref="main" />
		</div>
	</section>
</template>
<script>
	export default {
		name: 'AppMainV3',
	};
</script>
<style lang="scss" scoped>
	@import '~bulma/css/bulma.css';
	$page-width: 1400px;
	$page-padding: 20px;

	#app-main-v3 {
		overflow-x: auto;
	}

	#app-main-v3 ::v-deep {
		.btn,
		.btn-excel,
		.btn-main,
		.btn-delete,
		input {
			border-radius: 0;
		}

		.table-main {
			min-width: calc(
				#{$page-width} - #{$page-padding} - #{$page-padding} - 2px
			);
			table-layout: fixed;
		}
	}

	.admin-v3 {
		width: 100%;
		min-width: $page-width;
		margin: 0 auto;
		padding: $page-padding $page-padding $page-padding + 56px;
	}
</style>
